<div class="cancel-order-modal" [ngStyle]="(translate.currentLang=='ar') && {'direction': 'rtl', 'text-align': 'start'}">
  <mat-dialog-content>
    <p class="text-color-theme" style="white-space: pre-line;">
      {{message}}
    </p>
  </mat-dialog-content>
  <mat-dialog-actions align="center">
    <button class="btn btn-primary text-center mx-2" (click)="onConfirmClick()" type="submit" tabindex="1">{{'submit' | translate}}</button>
    <button class="btn btn-danger text-center" mat-dialog-close>{{'cancel' | translate}}</button>
  </mat-dialog-actions>
</div>
